var pdpZoom = {
  index: 0,
  pinches: [],
  startX: 0,
  startY: 0,
  ready: false
};

function pdpZoomTrack() {
  return document.getElementById('pdp-zoom-track');
}

function pdpZoomSlides() {
  return document.querySelectorAll('#pdp-zoom-track .pdp-zoom-slide');
}

function pdpMainSliders() {
  var sliders = [];
  var $for = $('.product__media-wrapper .slider-for');
  var $list = $('#productimages_sliders');
  if ($for.length && $for.hasClass('slick-initialized')) sliders.push($for);
  if ($list.length && $list.hasClass('slick-initialized')) sliders.push($list);
  return sliders;
}

function pdpSyncCarouselToZoom() {
  var zoomIdx = pdpZoom.index;
  var target = document.querySelector('.product__media-wrapper [data-zoom-index="' + zoomIdx + '"]');
  var slickIndex = target ? parseInt(target.getAttribute('data-slick-index'), 10) : zoomIdx;
  if (isNaN(slickIndex)) slickIndex = zoomIdx;

  pdpMainSliders().forEach(function ($slider) {
    $slider.slick('slickGoTo', slickIndex, true);
  });

  var $nav = $('.product__media-wrapper .slider-nav');
  if ($nav.length && $nav.hasClass('slick-initialized')) {
    $nav.slick('slickGoTo', slickIndex, true);
  }
}

function pdpCurrentZoomIndex() {
  var current = document.querySelector('.product__media-wrapper .slick-current[data-zoom-index]');
  if (!current) {
    current = document.querySelector('.product__media-wrapper .slick-current');
    if (current) {
      current = current.closest('[data-zoom-index]') || current.querySelector('[data-zoom-index]') || current;
    }
  }
  if (current && current.hasAttribute('data-zoom-index')) {
    var idx = parseInt(current.getAttribute('data-zoom-index'), 10);
    return isNaN(idx) ? 0 : idx;
  }
  return 0;
}

function pdpZoomReset(i) {
  var pz = pdpZoom.pinches[i];
  if (!pz) return;
  pz.zoomFactor = 1;
  pz.offset = { x: 0, y: 0 };
  if (pz.update) pz.update({ type: 'resize' });
}

function pdpZoomIsZoomed() {
  var pz = pdpZoom.pinches[pdpZoom.index];
  return pz && pz.zoomFactor > 1.05;
}

function pdpZoomGoTo(i) {
  var slides = pdpZoomSlides();
  if (!slides.length) return;
  pdpZoom.index = (i + slides.length) % slides.length;
  pdpZoomTrack().style.transform = 'translate3d(' + (-pdpZoom.index * 100) + '%,0,0)';
  for (var n = 0; n < slides.length; n++) pdpZoomReset(n);
}

function pdpZoomNav(dir) {
  if (pdpZoomIsZoomed()) pdpZoomReset(pdpZoom.index);
  pdpZoomGoTo(pdpZoom.index + dir);
}

function pdpZoomInit() {
  if (pdpZoom.ready || typeof PinchZoom === 'undefined') return;
  var els = document.querySelectorAll('#pdp-zoom-track .pinch-zoom');
  for (var i = 0; i < els.length; i++) {
    if (els[i].closest('.pinch-zoom-container')) continue;
    pdpZoom.pinches.push(new PinchZoom.default(els[i], {
      draggableUnzoomed: false,
      minZoom: 1,
      maxZoom: 4
    }));
  }

  var track = pdpZoomTrack();
  track.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    pdpZoom.startX = e.touches[0].clientX;
    pdpZoom.startY = e.touches[0].clientY;
  }, { passive: true });

  track.addEventListener('touchend', function (e) {
    if (pdpZoomIsZoomed() || !e.changedTouches.length) return;
    var dx = e.changedTouches[0].clientX - pdpZoom.startX;
    var dy = e.changedTouches[0].clientY - pdpZoom.startY;
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
    pdpZoomNav(dx < 0 ? 1 : -1);
  }, { passive: true });

  pdpZoom.ready = true;
}

function showzoompopup(input) {
  var popup = document.getElementById('mobilezoompopup');
  if (!popup) return;

  var idx = 0;
  if (typeof input === 'number') {
    idx = input;
  } else if (input && input.nodeType) {
    var slide = input.closest('[data-zoom-index]');
    idx = slide ? parseInt(slide.getAttribute('data-zoom-index'), 10) : 0;
    if (isNaN(idx)) idx = 0;
  }

  popup.classList.add('is-open');
  document.body.classList.add('hide-scrollbar');
  pdpZoomInit();
  pdpZoomGoTo(idx);
  setTimeout(function () {
    for (var i = 0; i < pdpZoom.pinches.length; i++) pdpZoomReset(i);
  }, 60);
}

function closezoompopup() {
  var popup = document.getElementById('mobilezoompopup');
  if (popup) popup.classList.remove('is-open');
  document.body.classList.remove('hide-scrollbar');
  pdpZoomReset(pdpZoom.index);
  pdpSyncCarouselToZoom();
}

/* Two-finger pinch on PDP gallery opens zoom modal */
document.addEventListener('DOMContentLoaded', function () {
  var gallery = document.querySelector('.product__media-wrapper');
  if (!gallery) return;
  gallery.addEventListener('touchstart', function (e) {
    if (e.touches.length < 2) return;
    if (document.getElementById('mobilezoompopup').classList.contains('is-open')) return;
    showzoompopup(pdpCurrentZoomIndex());
  }, { passive: true });
});
